export default {
  SAVE_LIST(state, persons) {
    state.persons = persons
  },
  DELETE(state, person) {
    const index = state.persons.items.indexOf(person)
    state.persons.items.splice(index, 1)
  },
  SAVE_FINGERS(state, fingers) {
    state.fingers = fingers
  },
}
